export default "__VITE_ASSET__DrkOX7CC__"